import React, { useEffect, useState } from 'react';
import { trackFbEvent } from '../utils/fbpixel';
export function StickyBottomBar() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past hero (approx 600px)
      if (window.scrollY > 600) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!visible) return null;
  return <div className="fixed bottom-0 left-0 w-full bg-brand-magenta p-4 z-40 md:hidden shadow-[0_-4px_24px_rgba(0,0,0,0.15)] animate-fade-in-up" data-id="element-299">
      <a href="#compra" onClick={() => trackFbEvent('InitiateCheckout', {
      content_name: 'Sticky CTA',
      value: 19990,
      currency: 'ARS'
    })} className="w-full block bg-white text-brand-magenta font-bold text-[15px] rounded-xl py-3.5 text-center shadow-sm" data-id="element-300">
        🔓 QUIERO EL MÉTODO pH-ZERO — $19.990
      </a>
    </div>;
}